import { Component } from "@/types"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { cx } from "@/utils/cx"
import { CourseFeatureSection } from "./CourseFeatureSection/CourseFeatureSection"
import { Stack } from "@/ui/atoms/layout/Stack"
export const COMPONENT_NAME = "courseFeatures"

export const presets = {}

export interface Props extends Component {}

export function CourseFeatures({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`bg-white`, className)} data-test={testId}>
      <MarketingSection removeXPadding>
        <Stack className="gap-24 lg:gap-40">
          <CourseFeatureSection
            contentOvertitle="Self-paced interactive learning"
            contentTitle="Learn your own way, at your own pace - with immersive videos and interactive labs."
            contentDescription="With engaging 4K video lectures, walk-through demonstrations, more than 60 hands-on labs, with audio recordings and knowledge checks throughout, you can learn however works best for you."
            contentImage="/content/marketing/features/feature-self-pace.webp"
            quoteOneContent="I think the SANS foundations course is probably the pinnacle of what online learning can be. Even though I had a strong grasp of most IT fundamentals, I found myself challenged in areas I hadn't explored before."
            quoteOneAuthor="Jake Danuser"
            quoteOneRole="Network Admin"
            quoteTwoContent="Very well rounded fundamentals course! I feel like I learned a lot more because the course covers so much different material that are related and build on each other to give you the big picture. Highly recommended!"
            quoteTwoAuthor="Matthew Draga"
            quoteTwoRole="SANS Foundations Student"
            className="text-teal-500"
          />

          <CourseFeatureSection
            flip
            contentOvertitle="Hands-on lab environments"
            contentTitle="Embedded labs to help master the practical skills"
            contentDescription="Learn how to navigate Linux, write computer programs in C and Python, and run common exploits, all from a safe space in your web browser."
            contentImage="/content/marketing/features/feature-labs.webp"
            quoteOneContent="The security labs were my personal favorite as the skills attained through those helped me land a role as a vulnerability analyst in the information security office!"
            quoteOneAuthor="Kirti Nangia"
            quoteOneRole="SANS Foundations Student"
            quoteTwoContent="The way the material was explained and the hands-on labs truly makes Foundations the best technical course I ever had."
            quoteTwoAuthor="Ahmed Jahaf"
            quoteTwoRole="SANS Foundations Student"
            className="text-orange-400"
          />

          <CourseFeatureSection
            contentOvertitle="The highest standard"
            contentTitle="Learn from the best in the business with SANS Chief Technology and Innovation Officer, James Lyne"
            contentDescription="Founded in 1989, SANS are respected leaders in cybersecurity education. In this course the SANS Chief Technical Officer and certified instructor James Lyne shares his extensive industry experience with an engaging teaching style and expert instruction."
            contentImage="/content/marketing/features/feature-mentor.webp"
            quoteOneContent="James Lyne is a ROCKSTAR! Great material and great delivery. Super knowledgeable and experienced. Thoroughly enjoyed this class."
            quoteOneAuthor="Scott Sivulich"
            quoteOneRole="SANS Foundations Student"
            quoteTwoContent="SANS Foundations has helped me learn the fundamentals of IT and Cybersecurity with great ease! James Lyne is a genius in his field and an excellent teacher in this course!"
            quoteTwoAuthor="Andrew Kamlet"
            quoteTwoRole="SANS Foundations Student"
            className="text-red-600"
          />

          <CourseFeatureSection
            flip
            contentOvertitle="Certified in four months"
            contentTitle="Join the 5,000+ people we’ve already certified"
            contentDescription="Cybersecurity professionals ranked GIAC certifications as the most valued certifications when selecting job candidates for interviews"
            contentSource="The CIO Institute."
            contentImage="/content/marketing/features/feature-gfact.webp"
            quoteOneContent="I have the confidence that the foundations have set the stage to not only complete my program at SANS but also have a rewarding career within the cybersecurity industry. I cannot recommend this course and program enough!"
            quoteOneAuthor="Myles Flott"
            quoteOneRole="SANS Foundations Student"
            quoteTwoContent="I would highly recommend SANS Foundations for beginners and intermediate cyber professionals who want to revisit the fundamentals and establish a solid base of knowledge to build your career on top of."
            quoteTwoAuthor="Austin Warden"
            quoteTwoRole="Cyber Security Professional"
            className="text-purple-600"
          />
        </Stack>
      </MarketingSection>
    </div>
  )
}
